import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import './ContactPage.css';

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className="contact-page">
      <Helmet>
        <title>{t('meta.contact.title')}</title>
        <meta name="description" content={t('meta.contact.description')} />
        <meta property="og:title" content={t('meta.contact.title')} />
        <meta property="og:description" content={t('meta.contact.description')} />
      </Helmet>

      <h1>{t('message.contact.title')}</h1>
      <p>{t('message.contact.mailDetail')}</p>
      <a href="mailto:park.sj.develop@gmail.com" className="email-link">
        park.sj.develop@gmail.com
      </a>
    </div>
  );
};

export default ContactPage;
